












import {defineComponent} from "@vue/composition-api";

export default defineComponent({
    props: {
        title: {
            type: String,
            required: false
        },
        description: {
            type: String,
            required: false
        },
        icon: {
            type: String,
            required: false
        },


    }
});

